import { AttributablePay } from '@fora-monorepo/employer-my-pages-common/types';

import { EmploymentPayData } from '../types';

export const getAttributablePayToReport = (payrollDataRow: EmploymentPayData): AttributablePay => {
  const attributablePayToReport = payrollDataRow.attributablePay ? [...payrollDataRow.attributablePay] : [];

  payrollDataRow.attributablePayReported?.forEach(({ attributablePayMonth }) => {
    const existsInAttributablePay = attributablePayToReport.some(
      ({ attributablePayMonth: payMonth }) => payMonth === attributablePayMonth
    );

    if (!existsInAttributablePay) {
      // Add missing months from attributablePayReported to attributablePay with amount 0
      attributablePayToReport.push({
        attributablePayMonth,
        attributablePayAmount: 0,
      });
    }
  });

  return attributablePayToReport;
};
